module.exports = __webpack_public_path__ + "static/img/model-like4.f3dfe4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-like4.png
// module id = Y1a/
// module chunks = 36